import useHeartbeat from 'src/hooks/useHeartbeat';
const HeartbeatManager = () => {
  useHeartbeat();
  return null;
};
export default HeartbeatManager;